// extracted by mini-css-extract-plugin
export var simpleCard = "SimpleProgramCard-module--simpleCard--3eKJj";
export var simpleCard__image = "SimpleProgramCard-module--simpleCard__image--1N1AN";